import { Box, DashboardModule } from '@domain-group/suit-theme'

import useAgencyPortals from '@hooks/useAgencyPortals'

import Portal from '../Portal'

interface PortalsProps {
  selectedAgencyId: number,
  disabled?: boolean,
}

const Portals = (props: PortalsProps) => {
  const { disabled, selectedAgencyId } = props

  const agencyPortalPayload = useAgencyPortals({
    filters: {
      agency_id: selectedAgencyId,
    },
    performHttpRequests: !!selectedAgencyId,
    requestOptions: {
      include_agency_portal_portal: true,
      include_portal_option_values: true,
      include_portal_options: true,
    },
  })

  const { filteredAgencyPortals, hasFilteredAgencyPortals, loading } = agencyPortalPayload

  return (
    <DashboardModule title="Portal Options" loading={loading}>
      {!loading && (
        <>
          {!hasFilteredAgencyPortals && (
            <DashboardModule.BlankState>
              <DashboardModule.BlankState.Title>
                You don&apos;t have any default agency portals.
              </DashboardModule.BlankState.Title>
            </DashboardModule.BlankState>
          )}

          {hasFilteredAgencyPortals && (
            // @ts-expect-error TS2322
            <DashboardModule.ScrollableSection maxHeight={600}>
              <Box flexDirection="column">
                {filteredAgencyPortals.map(agencyPortal => (
                  <Portal
                    agencyPortal={agencyPortal}
                    disabled={disabled}
                    key={agencyPortal.id}
                    selectedAgencyId={selectedAgencyId}
                  />
                ))}
              </Box>
            </DashboardModule.ScrollableSection>
          )}
        </>
      )}
    </DashboardModule>
  )
}

export default Portals
